




































import Vue from 'vue';
import { DashboardViewModel } from '../types';
import * as prestazioneApi from '../services/prestazione-api';

export default Vue.extend({
    components: {},
    data(): DashboardViewModel {
        return {
            items: [],
        };
    },
    methods: {
        open(id: number) {
            this.$router.push({
                name: 'PrestazioniStato',
                params: { statusId: id.toString() },
            });
        },
    },
    async mounted() {
        this.items = await prestazioneApi.getDashboard();
    },
});
